<script>
  import { userStore } from "../../store";
  let isUser = $userStore?.user?.user_type === 'USER';
</script>
{#if isUser}
  <slot></slot>
{/if}
